import { progressApi } from "utilities/Axios";
import { AlertHistoryProps } from "../types/alarmtypes";
import { alarmsAPI } from "./types/apiTypes";

export const updateAlarm = (tagId: number, status: number) => {
  return progressApi.get(`/AlertTag/SetAlertStatus?tagId=${tagId}&status=${status}`);
};

export const getAlarms= (): Promise<alarmsAPI> => {
  return progressApi.get("/AlertTag/GetAlertTagHistories");
};

export const updateAlarmHistory = (alarmId: number, status: number) => {
  return progressApi.get(
    `/AlertTag/SetAlertHistoryStatus?tagHistoryId=${alarmId}&status=${status}`
  );
};

export const deleteAlarm = (alarmId: number) => {
  return progressApi.get(`/AlertTag/DeleteAlertHistory?tagHistoryId=${alarmId}`);
};

export const getCount = (): Promise<number> => {
  return progressApi.get("/AlertTag/GetActiveAlertCount");
};

export const deleteAllAlarm = () => {
  return progressApi.get("/AlertTag/DeleteAllAlerts");
};

export const acceptAllAlarm = () => {
  return progressApi.get("/AlertTag/AcceptAllAlerts");
};

